import { createContext, useContext, useState } from 'react'

const AppContext = createContext()

/**
 * Provider component that wraps the app and manages global UI state
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 */
export const AppProvider = ({ children }) => {
  // Support modal state
  const [isSupportOpen, setIsSupportOpen] = useState(false)

  // Group related state and actions together by feature
  const appState = {
    support: {
      isOpen: isSupportOpen,
      open: () => setIsSupportOpen(true),
      close: () => setIsSupportOpen(false),
    },
  }

  return <AppContext.Provider value={appState}>{children}</AppContext.Provider>
}

export const useApp = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error('useApp must be used within an AppProvider')
  }
  return context
}
